import React from "react";
import "./dayschedule.css";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import { Box, Typography } from "@mui/material";
import TitleBox from "../../../../components/common/titleBox/TitleBox";
import { useDailyScheduleMasterHook } from "../../customHooks";
import { useEffect } from "react";
import IconButton from "@mui/material/IconButton";

function DailySchedule() {
  const {
    todaySchedule,
    updateDate,
    formatDateForDisplay,
    date,
    fetchSchedule,
  } = useDailyScheduleMasterHook();

  useEffect(() => {
    fetchSchedule();
  }, [date]);

  return (
    <>
      <TitleBox
        title={
          <Box className="dailyschedule-title">
            <Typography variant="h6">Day Schedule</Typography>
          </Box>
        }
        subcontent={
          <Box display="flex" justifyContent="space-around" alignItems="center">
            <IconButton className="arw-btn" onClick={() => updateDate(-1)}>
              <KeyboardDoubleArrowLeftIcon />
            </IconButton>

            <h5>
              {formatDateForDisplay(date)}
            </h5>

            <IconButton className="arw-btn" onClick={() => updateDate(1)}>
              <KeyboardDoubleArrowRightIcon />
            </IconButton>
          </Box>
        }
        content={
          <Box className="panchang-content2">
            <Box
              sx={{
                p: 3,
                maxHeight: "400px",
                overflowY: "auto",
                width: "100%",
              }}
            >
              <ul className="dayschedulel-list">
                  {todaySchedule?.map((Schedule, i) => (
                    <li key={i}>
                      <span>{Schedule.time}</span>
                      {Schedule.title}
                    </li>
                  ))}
              </ul>
            </Box>
          </Box>
        }
      />
    </>
  );
}

export default DailySchedule;
